// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginAPI, otpVerifyService, logoutService, fetchUserLoginDetailService, updateUserDetailService } from '../../api/auth';

const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (credentials, { rejectWithValue }) => {
        try {
            const data = await loginAPI(credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const VerifyUserOtp = createAsyncThunk(
    'auth/verifyOtp',
    async (credentials, { rejectWithValue }) => {
        try {
            const data = await otpVerifyService(credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

export const reduxUpdateUserDetail = createAsyncThunk("auth/updateUserDetail", (payload, { rejectWithValue }) => {
    return updateUserDetailService(payload)
        .catch(e => {
            return rejectWithValue(e.response?.data || 'Something went wrong');
        })
});

const logoutUser = createAsyncThunk(
    'auth/logoutUser',
    async (credentials, { rejectWithValue }) => {
        try {
            const data = await logoutService();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
);

const reduxFetchUserLoginDetail = createAsyncThunk("auth/fetchUserLoginDetail", async (payload) => {
    return fetchUserLoginDetailService();
});
const initialState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    showotp: true,
    userDetail: null,
    authState: false
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: state => {
            state.user = null;
            state.token = null;
            state.showotp = true

        },
        setuserDetail: (state, action) => {
            state.userDetail = {
                ...state.userDetail,
                portfolioAmt: action.payload.portfolioAmt,
                multibaggerAllocation: action.payload.multibaggerAllocation,
            };
        },
        setInitialuserDetail: (state, action) => {
            state.userDetail = {
                ...state.userDetail,
                isPortfolioRegCompleted: true,
            };
        }
    },
    extraReducers: builder => {
        builder
            .addCase(loginUser.pending, state => {
                state.loading = true;
                state.error = null;
                state.showotp = true
            })
            .addCase(loginUser.fulfilled, (state, action) => {

                state.loading = false;
                state.showotp = false
                // state.token = action.payload.token;
                state.user = { email: action.meta.arg.email };
                // localStorage.setItem('token', action.payload.token);
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.showotp = true
                state.error = action.payload;
            })

            .addCase(VerifyUserOtp.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(VerifyUserOtp.fulfilled, (state, action) => {
                if (typeof window !== 'undefined') {
                    localStorage.setItem('suat', action.payload.data.authentication.accessToken);
                    localStorage.setItem('rtust', action.payload.data.authentication.refreshToken);
                    localStorage.setItem('uid', action.payload.data.id);
                }
                state.authState = !!action.payload.data.authentication.accessToken
                state.userDetail = action.payload.data;
                state.loading = false;
                state.otpVerified = true;
                state.showotp = false;
            })
            .addCase(VerifyUserOtp.rejected, (state, action) => {
                state.loading = false;
                state.otpVerified = false;
                state.error = action.payload;
            });

        builder.addCase(logoutUser.pending, state => {
            // if (typeof window !== 'undefined') {
            //     localStorage.removeItem('suat');   // Access token
            //     localStorage.removeItem('rtust');  // Refresh token
            //     localStorage.removeItem('uid');    // User ID
            // }
            // state.authState = false
            state.loading = true;
            state.error = null;
        });
        builder.addCase(logoutUser.fulfilled, (state, action) => {
            state.accessToken = null
            state.reFreshToken = null
            state.authState = false
            state.userDetail = {}
            state.loginStep = 'mobile'
            localStorage.removeItem('suat');   // Access token
            localStorage.removeItem('rtust');  // Refresh token
            localStorage.removeItem('uid');    // User ID
        });
        builder.addCase(logoutUser.rejected, (state, action) => {
        });
        builder.addCase(reduxFetchUserLoginDetail.pending, state => {
        });
        builder.addCase(reduxFetchUserLoginDetail.fulfilled, (state, action) => {
            state.authState = !!action.payload.data.data
            state.userDetail = action.payload.data.data;
            if (typeof window !== 'undefined') {
                localStorage.setItem('uid', action.payload.data.data.id);
                localStorage.setItem('mobile', action.payload.data.data.mobile);
            }
        });
        builder.addCase(reduxFetchUserLoginDetail.rejected, (state, action) => {
        });
        builder.addCase(reduxUpdateUserDetail.pending, state => {
        });
        builder.addCase(reduxUpdateUserDetail.fulfilled, (state, action) => {
            const updatedUserDetail = action.payload?.data?.data || action.payload?.data || action.payload;
            state.loginStep = 'successfully_logged_in';
            state.userDetail = {
                ...state.userDetail,
                ...updatedUserDetail,
            };
        });
        builder.addCase(reduxUpdateUserDetail.rejected, (state, action) => {
            state.detailsErrorMessage = action.payload;
        });
    },
});

export const { logout, setuserDetail, setInitialuserDetail } = authSlice.actions;
export { loginUser, VerifyUserOtp, logoutUser, reduxFetchUserLoginDetail }
export default authSlice.reducer;
